module.exports = __webpack_public_path__ + "img/Umb43_uv_logotie_1083.9b061ccb.svg";